import Vue from 'vue'
import Vuex from 'vuex'
import {
	getToken
} from '@/utils/auth'
Vue.use(Vuex)
const store = new Vuex.Store({
	state: {
		basePicUrl: "https://wei-cai.oss-cn-beijing.aliyuncs.com/weicaiWeb/",
		majorId:0,
		baseUrls:"http://edu.whweicai.cn/weicaih5/#",
		userInfo:{},
		isChange:false,
		isShowPromotion:false
	},
});

export default store



//////////////////
// WEBPACK FOOTER
// ./store/index.js
// module id = vdRI
// module chunks = 4